import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { LuCoins, LuAward } from "react-icons/lu";
import { useWeb3Auth } from "../../hooks/useWeb3Auth";
import MemberCardDetail from "./MemberCard";
import useMintedNftList, { MintedNFT } from "../../hooks/useMintedNftList";
import RewardTab from "./RewardTab";
import "./index.css";
import { useWhiteboardRoom } from "../../hooks/useWhiteboardRoom";
import { createClickEngagementRecorder } from "../../utils/api";

const MemberCardList = () => {
  const { t } = useTranslation();
  const { isProticoAuthenticated, logout, address, proticoAuthenticate } =
    useWeb3Auth();
  const { mintedNftList } = useMintedNftList();
  const [currentTab, setCurrentTab] = React.useState("point");
  const { roomDomain } = useWhiteboardRoom();
  const clickRecorder = createClickEngagementRecorder(roomDomain, roomDomain);
  const onAuthentucateClick = async () => {
    await proticoAuthenticate();
  };

  return (
    <div className="membercard-container">
      <div className="membercard-tab-container">
        <div
          className={`membercard-tab-element ${
            currentTab === "point" ? "active" : ""
          }`}
          onClick={() => {
            setCurrentTab("point");
            clickRecorder("membercard_tab_point");
          }}
        >
          <LuCoins />
          <h4>{t("MemberCardAction_Tab_Point")}</h4>
        </div>
        <div
          className={`membercard-tab-element ${
            currentTab === "nft" ? "active" : ""
          }`}
          onClick={() => {
            clickRecorder("membercard_tab_nft");
            setCurrentTab("nft");
          }}
        >
          <LuAward />
          <h4>
            {t("MemberCardAction_Tab_Badge") + "(" + mintedNftList.length + ")"}
          </h4>
        </div>
      </div>
      {isProticoAuthenticated ? (
        <div className="membercard-main-container">
          {currentTab === "nft" ? (
            mintedNftList.map((nft) => <MemberCardPreview nft={nft} />)
          ) : (
            <RewardTab />
          )}
        </div>
      ) : !address ? (
        <div style={{ margin: "auto", textAlign: "center" }}>
          <p>{t("Engagement_Point_Record_Intro")}</p>
          <Button onClick={() => logout()} variant="outlined">
            {t("First_Message_Login_Button")}
          </Button>
        </div>
      ) : (
        <div style={{ margin: "auto", textAlign: "center" }}>
          <p>{t("Engagement_Point_Record_Intro")}</p>
          <Button onClick={() => onAuthentucateClick()} variant="outlined">
            {t("Please_sign_to_see_following_lobby_2")}
          </Button>
        </div>
      )}
    </div>
  );
};

export default MemberCardList;

const MemberCardPreview = ({ nft }: { nft: MintedNFT }) => {
  const [isCardDetailOpen, setIsCardDetailOpen] = React.useState(false);
  return (
    <>
      {isCardDetailOpen && (
        <MemberCardDetail nft={nft} setIsCardDetailOpen={setIsCardDetailOpen} />
      )}
      <div
        className="membercard-card-container"
        onClick={() => setIsCardDetailOpen(true)}
      >
        <div className="membercard-card-image-container">
          <img
            src={
              !!nft.domain_nft_logo
                ? nft.domain_nft_logo
                : "https://d1q39w3eq2bx7b.cloudfront.net/iota/chatting_chip_v2.png"
            }
          />
        </div>
        <div className="membercard-card-description-container">
          <h3>{nft.domain_nft_info.name}</h3>
          <p>{nft.domain_nft_info.symbol}</p>
        </div>
      </div>
    </>
  );
};
